import { Entity } from '../entity';
import { RecurringJob } from '../job/recurring.job';
import { ActivityEntityName } from '../shared/activity.entity.name';
import { ActivityTag } from '../shared/activity';
import { Asset } from './asset';
import { AssetLinkRequest } from './asset.request';

export interface AssetLink extends Entity {
    _id: string;
    entity: Entity;
    asset: Entity;
    lastServiceOn: Date;
    createdAt?: Date;
    createdBy?: Entity;
    updatedAt?: Date;
    updatedBy?: Entity;
    tags?: ActivityTag[];

    /** @description Calculated field */
    assetData?: Asset;
}

export interface CreateAssetRecurringJobAndLinkRequest {
    createRequest: Partial<RecurringJob>;
    assetId: string;
}


export interface AssetUnlinkRequest {
    jobId: string,
    assetId: string,
}



export enum AssetLinkCommandId {
    Link = 'Link',
    Unlink = 'Unlink',
    CreateAndLink = 'CreateAndLink',
    FillForm = 'FillForm',
}

export type AssetRecurringJobDashboardCommands =
    {
        commandId: AssetLinkCommandId.Unlink,
        data: AssetUnlinkRequest
    }
    | {
        commandId: AssetLinkCommandId.CreateAndLink,
        data: CreateAssetRecurringJobAndLinkRequest
    }


export type AssetLinkCommands =
    {
        commandId: AssetLinkCommandId.Link,
        data: AssetLinkRequest
    }
    | {
        commandId: AssetLinkCommandId.Unlink,
        data: AssetUnlinkRequest
    }
    | {
        commandId: AssetLinkCommandId.CreateAndLink,
        data: {
            entityId: string;
            entityType: ActivityEntityName;
            asset: Asset;
        }
    }

export enum AssetLinkSystemViewVariant {
    CardList = 'CardList',
}